<script setup lang="ts">
import { ref, useId } from 'vue';

const name = ref<string>(useId());
</script>

<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g :filter="`url(#${name}filter0_i_14949_165587)`">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5 17.736C14.5 16.6093 15.1859 15.6226 15.9665 14.8101C16.9162 13.8217 17.5 12.479 17.5 11C17.5 7.96243 15.0376 5.5 12 5.5C8.96243 5.5 6.5 7.96243 6.5 11C6.5 12.479 7.08379 13.8217 8.03352 14.8101C8.81413 15.6226 9.5 16.6093 9.5 17.736V19.5C9.5 20.8807 10.6193 22 12 22C13.3807 22 14.5 20.8807 14.5 19.5V17.736Z"
        fill="#F2BA00"
      />
    </g>
    <path
      d="M12 17.5V14M12 14L9.5 10.5M12 14L14.5 10.5"
      :stroke="`url(#${name}paint0_linear_14949_165587)`"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M10.5 21H13.5V21.5C13.5 22.3284 12.8284 23 12 23C11.1716 23 10.5 22.3284 10.5 21.5V21Z" fill="#3B364D" />
    <path d="M9.5 18H14.5V19.5C14.5 20.8807 13.3807 22 12 22C10.6193 22 9.5 20.8807 9.5 19.5V18Z" fill="#8D8998" />
    <path
      d="M20.5 11H22"
      :stroke="`url(#${name}paint1_linear_14949_165587)`"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 11H3.5"
      :stroke="`url(#${name}paint2_linear_14949_165587)`"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.0078 4.99023L19.0685 3.92957"
      :stroke="`url(#${name}paint3_linear_14949_165587)`"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.92969 18.0703L5.99035 17.0097"
      :stroke="`url(#${name}paint4_linear_14949_165587)`"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 2.5L12 1"
      :stroke="`url(#${name}paint5_linear_14949_165587)`"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.99219 4.99023L4.93153 3.92957"
      :stroke="`url(#${name}paint6_linear_14949_165587)`"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.0703 18.0703L18.0097 17.0097"
      :stroke="`url(#${name}paint7_linear_14949_165587)`"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <filter
        :id="`${name}filter0_i_14949_165587`"
        x="6.5"
        y="5.5"
        width="11"
        height="16.5"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.95 0 0 0 0 0.728333 0 0 0 0 0 0 0 0 1 0" />
        <feBlend mode="multiply" in2="shape" result="effect1_innerShadow_14949_165587" />
      </filter>
      <linearGradient
        :id="`${name}paint0_linear_14949_165587`"
        x1="12"
        y1="10"
        x2="12"
        y2="17.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFF6D5" />
        <stop offset="1" stop-color="#F2BA00" />
      </linearGradient>
      <linearGradient
        :id="`${name}paint1_linear_14949_165587`"
        x1="22"
        y1="11.5"
        x2="20.5"
        y2="11.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAC700" stop-opacity="0.5" />
        <stop offset="1" stop-color="#F2BA00" />
      </linearGradient>
      <linearGradient
        :id="`${name}paint2_linear_14949_165587`"
        x1="3.5"
        y1="11.5"
        x2="2"
        y2="11.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAC700" stop-opacity="0.5" />
        <stop offset="1" stop-color="#F2BA00" />
      </linearGradient>
      <linearGradient
        :id="`${name}paint3_linear_14949_165587`"
        x1="19.422"
        y1="4.28313"
        x2="18.3614"
        y2="5.34379"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAC700" stop-opacity="0.5" />
        <stop offset="1" stop-color="#F2BA00" />
      </linearGradient>
      <linearGradient
        :id="`${name}paint4_linear_14949_165587`"
        x1="6.3439"
        y1="17.3632"
        x2="5.28324"
        y2="18.4239"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAC700" stop-opacity="0.5" />
        <stop offset="1" stop-color="#F2BA00" />
      </linearGradient>
      <linearGradient
        :id="`${name}paint5_linear_14949_165587`"
        x1="12.5"
        y1="1"
        x2="12.5"
        y2="2.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAC700" stop-opacity="0.5" />
        <stop offset="1" stop-color="#F2BA00" />
      </linearGradient>
      <linearGradient
        :id="`${name}paint6_linear_14949_165587`"
        x1="5.28508"
        y1="3.57602"
        x2="6.34574"
        y2="4.63668"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAC700" stop-opacity="0.5" />
        <stop offset="1" stop-color="#F2BA00" />
      </linearGradient>
      <linearGradient
        :id="`${name}paint7_linear_14949_165587`"
        x1="18.3632"
        y1="16.6561"
        x2="19.4239"
        y2="17.7168"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAC700" stop-opacity="0.5" />
        <stop offset="1" stop-color="#F2BA00" />
      </linearGradient>
    </defs>
  </svg>
</template>
